import React, {Component} from 'react';
import SearchResult from "./SearchResult";
import { Trans } from 'react-i18next';

class SearchResults extends Component {

  componentDidMount() {
    if (this.props.results.length > 0 && !this.props.results.paging.self.href.includes('&page')) {
      this.props.addPaging();
    }
  }


  render() {
    let resultComponents = [];
    this.props.results.map((result) => (resultComponents.push(<SearchResult key={result.drupal_internal__nid} result={result}/>)));
    let noResults = (
      <Trans i18nKey="search_results.message_no_results">
        <h3>Sorry, no results found.</h3>
        <p>Perhaps you misspelled your search query, or need to try using broader search terms.</p>
      </Trans>
    );

    if (resultComponents.length == 0) {
      resultComponents = noResults;
    }
    return (
      <div className="venues">
        <h2 className="sr-only">
          Venues
        </h2>
        <div className="venues__inner">
          {resultComponents}
        </div>
      </div>
    );
  }
}

export default SearchResults;
